/* eslint-disable id-length */
import keyMirror from 'keymirror';

export default keyMirror({
  FAQ_SECTION_TITLE_RENDERED: null,
  FAQ_SECTION_DESCRIPTION_RENDERED: null,
  FAQ_QUESTION_RENDERED: null,
  FAQ_ANSWER_RENDERED: null,
  FAQ_BACK_LINK: null,
  FAQ_ARTICLE_TOPIC: null,
  FAQ_ARTICLE_TITLE: null,
  FAQ_ARTICLE_BODY: null
});
